import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalTambah extends React.Component {
    render() {
        const { ShowModalDel2, CancelHandler, DeleteHandlerr, Model, ListDelete, DeleteHandlerr2 } = this.props
        return (

            <div>
                <Modal show={ShowModalDel2} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>BATALKAN RENCANA KEDATANGAN</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Anda yakin ingin membatalkan {ListDelete.length} rencana kedatangan?
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={CancelHandler}>Tidak</button>
                        <button class="btn btn-danger" onClick={DeleteHandlerr2}>Yakin</button>

                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}